import './App.css';
import { useEffect, useState, useRef } from 'react'
import Form from "./form2";
import Modal from 'react-modal';
import Logopikku from "./Pro2.jpg";
import AI from "./AI2.png";
import ConAdd from "./ConAdd";
import ConMan from "./ConMan";

function Hallinta() {

  const [tunnus, setTunnus] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [login, setLogin] = useState(false);
  const [authentication, setAuthentication] = useState(false);
  const [form, setForms] = useState(false);
  const [flag, setFlags] = useState(false);
  const [konsultit, setKonsultit] = useState([]);
  const [finland, setFinland] = useState(false);
  const [mandaatit, setMandaatit] = useState([]);
  const [yritys, setYritys] = useState([]);
  const [position, setPosition] = useState([]);
  const [hakijat, setHakijat] = useState([]);
  const [tcg, setTcg] = useState(false);
  const [group, setGroup] = useState("");
  const [language, setLanguage] = useState(() => localStorage.getItem('consultantLanguagePreference') || "fi");


  const addLogin = (value) => {
    setLogin(true);
};

const addKonsultit = (value) => {
    setKonsultit(value);
};
const addGroup = (value) => {
    setGroup(value);
    
};
const addTcg = (value) => {
    setTcg(value);
};

const handleLanguageChange = (event) => {
  setLanguage(event.target.value);
};

useEffect(() => {
  localStorage.setItem('consultantLanguagePreference', language);
}, [language]);

const addMandaatit = (value,yritys,position,name, hakijat) => {
  setMandaatit(value);
  setYritys(yritys);
  setPosition(position);
  setTunnus(name);
  setHakijat(hakijat);
};

  const handleCloseModal = () => {
    setIsOpen(false);
  }


  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);


    // Komponentin poistuessa, poista tapahtumankäsittelijä
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  const myRef = useRef();

      useEffect(() => {
        myRef.current.focus();
  }, [flag]);

  
  return (
    <div className="Front" ref={myRef}>
      <div className="LanguageSwitcher">
        <label htmlFor="language-select">Language:</label>
        <select
          id="language-select"
          value={language}
          onChange={handleLanguageChange}
        >
          <option value="fi">Suomi</option>
          <option value="en">English</option>
          <option value="sv">Svenska</option>
        </select>
      </div>
      {(!login && mandaatit.length < 1) && <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={handleCloseModal}
        contentLabel="Esimerkki modaali"
        shouldCloseOnOverlayClick={false}
        className={form ? "ChoiceModal" : "AppModal"}
        overlayClassName="AppModalOverlay">


        {!authentication && <Form onAddLogin={addLogin} onaddKonsultit={addKonsultit} onAddMandaatit={addMandaatit} onAddTcg={addTcg} onAddGroup={addGroup} language={language}/>} 

      </Modal>}

      {(isOpen )&& <div><img src={AI} className='AI2' alt="The Interview Simulator"/></div>}
      {(isOpen && !login && mandaatit.length < 1) && <div><img src={Logopikku} className='LomakeLogo' alt="Lassi Albin"></img></div>}
      {(isOpen && !login && mandaatit.length < 1) && <div><h1 className='LomakeTitle'>The Interview Simulator</h1></div>} 
      {(isOpen && !login && mandaatit.length < 1) && <div><h1 className='Footer'>© 2025 TCG. ALL RIGHTS RESERVED.</h1></div>}   
      {(login && mandaatit.length < 1) && <ConAdd kon={konsultit} t={tcg} g={group}/>}
      {mandaatit.length > 0 && <ConMan lan={language} kon={mandaatit} yri={yritys} pos={position} nam={group} hak={hakijat}/>}
      
        
      
    </div>
  );}
  
export default Hallinta;